var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"equaliser-container pl-2"},_vm._l((4),function(index){return _c('ol',{key:index,staticClass:"equaliser-column"},[_c('li',{staticClass:"colour-bar"})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }